export default __webpack_public_path__ + "static/media/ms_logo2.965424bc.png";